type EvaticJobId = {
  ProjectTaskId: string;
  ProjectNo: string;
  TaskNo: string;
  ProjectTaskAssignmentId: string;
};

export const jobIdParser = (jobId: string): EvaticJobId => {
  var parts = jobId.split("-");
  return {
    ProjectTaskId: parts[0],
    ProjectNo: parts[1],
    TaskNo: parts[2],
    ProjectTaskAssignmentId: parts[3],
  };
};
